const ITEMS = [
    "Comunicação Visual",
    "Serigrafia",
    "Sublimação",
    "Adesivos",
    "Fachadas",
    "Banners e Faixas",
    "Uniformes",
    "Envelopamento Automotivo",
    "Cartões de Visita",
    "Panfletos",
    "Placas",
];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div data-testid="services-marquee" aria-hidden="true" className="overflow-hidden bg-brand py-4">
            <div className="flex w-max animate-marquee items-center gap-8 pr-8">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-8 whitespace-nowrap">
                        <span className="font-display text-sm font-extrabold uppercase tracking-[0.18em] text-ink">{item}</span>
                        <span className="h-1.5 w-1.5 rotate-45 bg-ink" />
                    </span>
                ))}
            </div>
        </div>
    );
};
